(function(window, document) {
  /**
   * Clears all cookies by setting expiration to past date,
   * and removes GTM and HubSpot scripts.
   */
  const clearAllCookies = function() {
    // Removing GTM scripts
    Array.from(document.querySelectorAll('script[src*="googletagmanager.com"]'))
      .forEach(script => script.remove());

    // Removing Google Analytics scripts
    Array.from(document.querySelectorAll('script[src*="google-analytics.com"]'))
      .forEach(script => script.remove());

    // Removing HubSpot script
    const hubSpotScript = document.getElementById('hs-script-loader');
    if (hubSpotScript) hubSpotScript.remove();

    // Clear all cookies
    const cookies = document.cookie.split('; ');
    cookies.forEach(cookie => {
      const name = cookie.split('=')[0].trim();

      // Skip the 'cookieconsent_status' cookie to preserve user consent status
      if (name === 'cookieconsent_status') return;

      // Attempt to delete the cookie without specifying domain or path
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;

      // Attempt to delete the cookie for all possible domain levels
      const hostnameParts = window.location.hostname.split('.');
      while (hostnameParts.length > 0) {
        const domain = '.' + hostnameParts.join('.');
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=${domain};`;
        hostnameParts.shift();
      }
    });
  };

  /**
   * Loads multiple Google Tag Manager scripts.
   * @param {{env:string[]; id: string;}} gtmConfig - An array of GTM config.
   */
  const loadGTMs = function (gtmConfig) {
    const hostname = window.location.hostname;

    let currentEnv = 'prod';
    if (
      hostname.includes('localhost')
      || hostname.includes('.dev')
      || hostname.includes('.ptp.dev')
      || hostname.includes('.test')
      || hostname.includes('.lndo.site')
    ) {
      currentEnv = 'dev';
    }

    const filteredGTMIds = (gtmConfig || [])
      .filter(gtm => gtm.env.includes(currentEnv))
      .map(gtm => gtm.id);

    filteredGTMIds.forEach(gtmId => {
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        const f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l !== 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', gtmId);

      const noscript = document
        .createElement('noscript');

      noscript.innerHTML = `<iframe
        src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
        height="0"
        width="0"
        style="display:none;visibility:hidden"></iframe>`;

      const body = document.body;
      if (body.firstChild) {
        body.insertBefore(noscript, body.firstChild);
      } else {
        body.appendChild(noscript);
      }
    });
  };

  /**
   * Function to load HubSpot tracking script.
   * @param {string} hubSpotUrl - The URL of the HubSpot script.
   */
  const loadHubSpot = function(hubSpotUrl) {
    if (!hubSpotUrl) return;

    const script = document.createElement('script');

    script.type = "text/javascript";
    script.id = "hs-script-loader";
    script.async = true;
    script.defer = true;
    script.src = hubSpotUrl;

    document.head.appendChild(script);
  };

  // Connect Osano Open Source
  window.addEventListener("load", function() {
    // Retrieve the site's configuration for GDPR cookie settings, if available
    const siteConfig = window.ogGDPRCookieConfig || {};
    const cookieConsentOptions = siteConfig.cookieConsentOptions || {};

    // Check for the presence of the 'cookieconsent_status' cookie
    // This regex matches the cookie if it is set to 'deny', 'allow', or 'dismiss'
    const matchCookieStatus = document.cookie
      .match(/(?:^|;\s*)cookieconsent_status=(deny|allow|dismiss)/);

    // If the cookie is not present or explicitly set to 'deny', clear all cookies
    if (!matchCookieStatus || matchCookieStatus[1] === 'deny') {
      clearAllCookies();
    }

    // Initialize the cookie consent popup
    window.cookieconsent.initialise(
      {
        theme: 'classic',
        position: cookieConsentOptions.position || 'bottom',
        type: 'opt-in',
        palette: {
          popup: {
            background: '#fff',
            link: '#205977'
          },
          button: {
            text: '#fff',
            background: cookieConsentOptions.buttonBackground || '#000'
          },
        },
        content: {
          message: 'We collect and use identifiers such as cookies to make it easier for you to use our website and give you a better experience. By using this website, you consent to Organogenesis using website identifiers, including cookies, for these purposes. To read our privacy policy, click',
          allow: 'Accept All Cookies',
          deny: 'Reject All',
          link: 'here',
          href: 'https://organogenesis.com/privacy.html',
          ...cookieConsentOptions.content
        },
        window:
          '<div role="dialog" aria-live="polite" aria-label="cookieconsent" aria-describedby="cookieconsent:desc" class="cc-window {{classes}}"><div class="container d-xl-flex">{{children}}</div></div>',
        onPopupOpen: function() {
          clearAllCookies();
        },
        onInitialise: function() {
          if (this.hasConsented()) {
            loadGTMs(siteConfig.gtmIds || []);
            loadHubSpot(siteConfig.hubSpotUrl);
          }
        },
        onStatusChange: function() {
          if (this.hasConsented()) {
            loadGTMs(siteConfig.gtmIds || []);
            loadHubSpot(siteConfig.hubSpotUrl);
          }
        }
      }
    );
  });
})(window, document);
